<template id="faq">
  <v-ons-page>
    <custom-toolbar :title="'FAQ'" :action="toggleMenu"></custom-toolbar>
    <div class="content-box">
      <FAQcards />
    </div>
  </v-ons-page>
</template>

<style scoped>
.content-box {
  margin-top: 60px;
}

.bottom-bar {
  background-color: #4abca5;
  border-top-style: solid;
  border-top-color: #837d89;
  border-top-width: 5px;
}
</style>

<script>
import customToolbar from "./PageNav.vue";
import FAQcards from "./CardsFAQ.vue";

export default {
  name: "FAQ",
  template: "faq",
  props: ["toggleMenu"],
  components: {
    customToolbar,
    FAQcards,
  },
};
</script>
